import { SimpleOption } from '../../../../../components/Option'
import { controlList } from '../../../storage'
import writeXlsxFile from 'write-excel-file'
import { get } from '../../../../../utilities/http'
import { buildPath } from '../../../../../sections/ModalPrint/utils'
import { InventoryBookExcel, InventoryBookExcelResponse } from '../../../types'
import Notify from '../../../../../utilities/Notify'
import moment from 'moment'

export default function OptionExcel() {
    async function download() {
        try {
            const companyId = controlList.filter.getParam('company_id')
            const startDate = moment(
                controlList.filter.getParam('start_date')
            ).format('YYYY-MM-DD')
            const endDate = moment(
                controlList.filter.getParam('end_date')
            ).format('YYYY-MM-DD')

            const response = await get<InventoryBookExcelResponse>(
                buildPath('/v5.6/apis/inventory_book/excel', [
                    ['company_id', companyId],
                    ['start_date', startDate],
                    ['end_date', endDate]
                ])
            )

            if (response.error || !response.data) {
                if (response.error?.type === 'cancel') {
                    Notify.error(
                        'La descarga anterior fue interrumpida. Intenta nuevamente.'
                    )
                    return
                }
                throw new Error(
                    response.error?.message ||
                        'No se pudo obtener la data del reporte'
                )
            }

            const payload: any = response.data
            const reportData = Array.isArray(payload?.result)
                ? payload
                : payload?.result || {}
            const data = reportData?.result || []
            const metadata = reportData?.metadata || {
                month_label: '',
                tax_period_end_date: moment(endDate).format('DD/MM/YYYY'),
                company_business_name: '',
                company_rif: '',
                currency_label: 'BOLIVARES'
            }
            const totals = reportData?.totals || {
                initial_inventory_balance: 0,
                input_value: 0,
                output_value: 0,
                retiros_value: 0,
                final_inventory_balance: 0
            }

            const titleRow = [
                { value: '' },
                {
                    value: 'REGISTRO DETALLADO DE ENTRADAS Y SALIDAS DE INVENTARIO DE MERCANCIAS',
                    span: 11,
                    fontWeight: 'bold' as const,
                    align: 'center' as const
                },
                { value: '' }
            ]

            const metaRowMonth = [
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: 'MES',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: metadata.month_label,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const metaRowFiscal = [
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: 'EJERCICIO GRAVABLE',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: metadata.tax_period_end_date,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const metaRowCompany = [
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: 'RAZON SOCIAL O DENOMINACION COMERCIAL',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: metadata.company_business_name,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const metaRowRif = [
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: 'RIF DEL CONTRIBUYENTE',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: metadata.company_rif,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const metaRowDates = [
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: 'FECHA INICIAL',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: startDate,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                {
                    value: 'FECHA FINAL',
                    span: 2,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                { value: '' },
                {
                    value: endDate,
                    span: 2,
                    align: 'center' as const,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' }
            ]

            const emptyRow = [
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const headerRow1 = [
                {
                    value: 'CODIGO',
                    rowSpan: 2,
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'DESCRIPCION',
                    rowSpan: 2,
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'EXISTENCIA INICIAL',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'ENTRADAS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'SALIDAS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'RETIROS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'EXISTENCIA FINAL',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'VALOR INVENTARIO',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'ENTRADAS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'SALIDAS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'RETIROS',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'EXISTENCIA Bs.',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: 'COSTO UNITARIO',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                }
            ]

            const headerRow2 = [
                { value: '' },
                { value: '' },
                {
                    value: 'UNIDADES',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8',
                    span: 5
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: `MONTO EXPRESADO EN ${metadata.currency_label}`,
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8',
                    span: 6
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: '',
                    backgroundColor: '#e8e8e8'
                }
            ]

            const dataRows = data.map((row: InventoryBookExcel) => [
                { value: row.product_code, type: String },
                { value: row.product_description, type: String },
                {
                    value: row.initial_inventory_quantity,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.inputs,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.outputs,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.retiros,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.final_inventory_quantity,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.initial_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.input_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.output_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.retiros_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.final_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.unit_cost,
                    type: Number,
                    format: '0.0000',
                    align: 'center' as const
                }
            ])

            // Fila de totales
            const totalsRow = [
                {
                    value: 'TOTALES',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.initial_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.input_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.output_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.retiros_value,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.final_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                }
            ]

            const excelData = [
                titleRow,
                emptyRow,
                metaRowMonth,
                metaRowFiscal,
                metaRowCompany,
                metaRowRif,
                metaRowDates,
                emptyRow,
                headerRow1,
                headerRow2,
                ...dataRows,
                totalsRow
            ]

            // Configurar anchos de columnas
            const columns = [
                { width: 18 },
                { width: 56 },
                { width: 14 },
                { width: 12 },
                { width: 12 },
                { width: 12 },
                { width: 14 },
                { width: 15 },
                { width: 12 },
                { width: 12 },
                { width: 12 },
                { width: 15 },
                { width: 14 }
            ]

            const fileName = `libro_inventario_${startDate}_${endDate}.xlsx`

            await writeXlsxFile(excelData, {
                fileName,
                columns
            })

            Notify.success('El archivo Excel se ha descargado correctamente')
        } catch (error) {
            Notify.error(
                'No se pudo descargar el reporte. Por favor, intenta nuevamente.'
            )
        }
    }

    return <SimpleOption onClick={download}>Exportar en Excel</SimpleOption>
}
